/* eslint-disable import/no-default-export, max-len */
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = props => /*#__PURE__*/_jsx("svg", {
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M22.393 17.057h-2.327c-.06 0-.12.01-.17.03-.268-2.148-2.048-3.809-4.196-3.809-2.138 0-3.909 1.651-4.187 3.78H1.607c-.328 0-.607.278-.607.606s.279.607.607.607h9.906c.278 2.128 2.049 3.78 4.187 3.78 2.148 0 3.929-1.662 4.197-3.81.05.02.11.03.17.03h2.326c.328 0 .607-.279.607-.607s-.279-.607-.607-.607zm-6.693 3.78c-1.671 0-3.034-1.422-3.034-3.173s1.363-3.173 3.034-3.173c1.67 0 3.033 1.423 3.033 3.173s-1.362 3.173-3.033 3.173zM22.393 5.72h-9.906C12.21 3.59 10.438 1.95 8.3 1.95c-2.148 0-3.929 1.65-4.197 3.8a.464.464 0 00-.17-.03H1.608A.615.615 0 001 6.325c0 .328.279.597.607.597h2.327c.06 0 .12-.01.17-.03.268 2.148 2.048 3.819 4.196 3.819 2.138 0 3.919-1.651 4.197-3.79h9.896A.607.607 0 0023 6.327a.616.616 0 00-.607-.607zM8.3 9.508c-1.67 0-3.033-1.433-3.033-3.183S6.629 3.143 8.3 3.143s3.034 1.433 3.034 3.183S9.97 9.509 8.3 9.509z"
  })
});
export default SvgFilter;